/**
 * Help Desk Endpoints
 */
export const HELP_DESK_ENDPOINTS = {
  getTickets: 'ticket/get-tickets',
  approveRejectTicket: 'ticket/approve-reject-ticket',
  getReasonList: 'ticket/ticket-reasons',
  createTicketReason: 'ticket/create-ticket-reason',
  enableDisableReason: 'ticket/enable-disable-ticket-reason',
  addUpdateHelpDeskNumber: 'ticket/add-update-helpdesk-number',
  getClientTicketsList: 'ticket/get-client-tickets',
  approveRejectClientTicket: 'ticket/client-approve-reject-ticket',
} as const;
